import React, {Suspense, useEffect, useState} from 'react';
import {Box} from '@mui/material';
import {Loading, NotificationBar} from '@/components/Common/Lib';
import { Container } from '@mui/material';
import PwaInstallBanner from "@/components/PwaInstallBanner/PwaInstallBanner";
import {Header, Sidebar, BottomNav} from "@/components/Navigation";
import {Outlet} from "react-router-dom";
import MessagesComponent from '../components/Messages/MessagesComponent';
import useIsMobileDisplay from '../hooks/useIsMobileDisplay';
import {useLayoutContext} from '@/context/LayoutContext';
import {TutorialProvider} from '@/context/TutorialContext';
import {BreadcrumbProvider} from '@/context/BreadcrumbContext';
import SpotlightOverlay from '@/components/Tutorial/SpotlightOverlay';
import useSiteStatusQuery from '@/behavior/init/hooks/useSiteStatusQuery';

const AppComponent = () => {
  const { sidebar, closeSidebar, openSidebar, toggleSidebar, setScreenWidth } = useLayoutContext();
  const { data: siteStatus } = useSiteStatusQuery();
  const [isNotificationBarShown, updateIsNotificationBarShown] = useState(true);
  const isMobileDisplay = useIsMobileDisplay();

  useEffect(() => {
    let xDown = null;
    let yDown = null;
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    function getTouches(evt) {
      return evt.touches || evt.originalEvent.touches;
    }

    function handleTouchStart(evt) {
      const firstTouch = getTouches(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
    }

    function handleTouchMove(evt) {
      if (!xDown || !yDown) return;
      const xUp = evt.touches[0].clientX;
      const yUp = evt.touches[0].clientY;
      const xDiff = xDown - xUp;
      const yDiff = yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {
          if (isMobileDisplay) closeSidebar();
        } else if (isMobileDisplay && xDown < window.innerWidth / 4) {
          openSidebar();
        }
      }
      xDown = null;
      yDown = null;
    }

    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);
    window.addEventListener('resize', handleResize);
  }, []);

  return (
    <TutorialProvider>
      <BreadcrumbProvider>
      {!isMobileDisplay && <Sidebar isExpanded={sidebar} onToggle={toggleSidebar}/>}
      <Box className={`main-content-wrapper${sidebar && !isMobileDisplay ? ' sidebar-expanded' : ''}${isMobileDisplay ? ' mobile' : ''}`}>
        <Header onMenuToggle={toggleSidebar}/>
        <Box component="main" className="main-content">
          <MessagesComponent/>
          <Container id="app-main-container" >
            <Suspense fallback={<Loading isLoading/>}>
              <Outlet/>
            </Suspense>
          </Container>
          {siteStatus && isNotificationBarShown && (
            <NotificationBar
              notificationText={siteStatus.text}
              updateIsNotificationBarShown={updateIsNotificationBarShown}
            />
          )}
        </Box>
      </Box>
      <BottomNav/>
      <PwaInstallBanner/>
      <SpotlightOverlay/>
      </BreadcrumbProvider>
    </TutorialProvider>
  );
};

export default AppComponent;
